import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractControl, FormArray } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Observable } from 'rxjs';

import { IModule } from 'module/module';
import { IModulePage } from 'module/page/module-page';
import { SidebarPlanModule } from 'presentation/app-sidebar/sidebar-coaching-plan/coaching-plan.models';

import { SectionEditModuleController } from './section-edit-module.controller';
import { SectionEditModuleStore } from './section-edit-module.store';

@Component({
	selector: 'spr-section-module-edit',
	templateUrl: './section-edit-module.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [SectionEditModuleStore, SectionEditModuleController],
	host: {
		class: 'flex flex-col items-stretch space-y-6',
	},
})
export class SectionEditModuleComponent {
	public pagesArray: FormArray;
	public schemeOptions: SelectItem[];
	public module$: Observable<IModule>;
	public uploading$: Observable<boolean>;
	public typeOptions$: Observable<SelectItem[]>;
	public pages$: Observable<ReadonlyArray<IModulePage>>;

	@Input() public panel: OverlayPanel;

	constructor(private _controller: SectionEditModuleController) {
		this.schemeOptions = [
			{ value: 'http', label: 'http://' },
			{ value: 'https', label: 'https://' },
		];
		this.pagesArray = _controller.form.get('pages') as FormArray;
		this.typeOptions$ = _controller.typeOptions$;
		this.uploading$ = _controller.uploading$;
		this.module$ = _controller.module$;
		this.pages$ = _controller.pages$;
	}

	@Input()
	public set module(module: SidebarPlanModule) {
		this._controller.updateState(module.instance.id, module.userId);
	}

	public onSaveClick() {
		this._controller.updateModule().then(() => this.panel.hide());
	}

	public onFileChange(
		e: any,
		file: HTMLInputElement,
		pageControl: AbstractControl
	) {
		this._controller.generateDocumentUrl(e.target.files[0], pageControl);
		file.value = null;
	}
}
